import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "project-create-form-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "grid-x" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "heading h1 page-title" }, " Position details ")
], -1)
const _hoisted_3 = { class: "project-create-form grid-x" }
const _hoisted_4 = { class: "form-column-wrapper cell small-12 medium-6" }
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "body-text-lg text-w-bold" }, " Role title ", -1)
const _hoisted_7 = { class: "input-group" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "body-text-lg text-w-bold" }, " Years of experience ", -1)
const _hoisted_9 = { class: "input-group" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "body-text-lg text-w-bold" }, " Budgeted hourly rate (USD) ", -1)
const _hoisted_11 = { class: "input-group with-subtext" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "flex-container flex-dir-column" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "body-text-lg text-w-bold" }, " Main Skills "),
  /*#__PURE__*/_createElementVNode("span", { class: "body-text-sm text-purple" }, "*Select a maximum of 3 skills")
], -1)
const _hoisted_13 = { class: "form-column-wrapper cell small-12 medium-6" }
const _hoisted_14 = { class: "input-group with-subtext" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "grid-x flex-dir-column" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "body-text-lg text-w-bold" }, " Secondary Skills "),
  /*#__PURE__*/_createElementVNode("span", { class: "body-text-sm text-purple" }, "*Select a maximum of 3 skills")
], -1)
const _hoisted_16 = { class: "input-group" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "body-text-lg text-w-bold" }, " Job description ", -1)
const _hoisted_18 = { class: "input-group" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "body-text-lg text-w-bold" }, " Job description link ", -1)
const _hoisted_20 = { class: "button-container grid-x align-center" }
const _hoisted_21 = { class: "cell small-12 large-4" }

import { ref } from 'vue'
import { NForm, NFormItem, NInput, NSelect, NButton, FormInst } from 'naive-ui';
import { SearchFilled } from '@vicons/material';
import { useSkillsStore } from "@/stores/skills.store";
import { ProjectFormProps} from "@/ts/interfaces/component-props";
import { projectFormRules } from "@/ts/formValidationRules";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectForm',
  props: {
    formData: {}
  },
  emits: [ 'submitAction' ],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

const skillStore = useSkillsStore()

skillStore.listSkills()

const yearsOfExperienceOptions = [
  {
    label: 'Between 1-3 years',
    value: '1-3'
  },
  {
    label: 'Between 3-5 years',
    value: '3-5'
  },
  {
    label: 'More than 5 years',
    value: '5+'
  },
]

const hourlyRateOptions = [
  {
    label: 'Between $30-50 USD',
    value: '30-50'
  },
  {
    label: 'Between $50-70 USD',
    value: '50-70'
  },
  {
    label: 'Between $70-$100 USD',
    value: '70-100'
  },
]

const formRef = ref<FormInst | null>(null)

const submit = () => {
  formRef.value?.validate((errors) => {
    if (!errors) {
      emit('submitAction')
    }
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_unref(NForm), {
      ref_key: "formRef",
      ref: formRef,
      model: _ctx.formData,
      rules: _unref(projectFormRules)
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_unref(NFormItem), {
                label: "Role Title",
                path: "role_title"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInput), {
                    value: _ctx.formData.role_title,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.role_title) = $event)),
                    size: "medium",
                    round: "",
                    placeholder: "Type the role title here",
                    class: "form-input"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_unref(NFormItem), {
                label: "Years of experience",
                path: "years_of_experience"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NSelect), {
                    value: _ctx.formData.years_of_experience,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.years_of_experience) = $event)),
                    options: yearsOfExperienceOptions,
                    size: "large",
                    placeholder: "Select the years of experience"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_unref(NFormItem), {
                label: "Budgeted hourly rate",
                path: "usd_hourly_rate"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NSelect), {
                    value: _ctx.formData.usd_hourly_rate,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.usd_hourly_rate) = $event)),
                    options: hourlyRateOptions,
                    size: "large",
                    placeholder: "Select here the expected hourly rate"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_unref(NFormItem), {
                label: "Main Skills",
                path: "skills"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NSelect), {
                    value: _ctx.formData.skills,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.skills) = $event)),
                    options: _unref(skillStore).skills,
                    size: "large",
                    placeholder: "Type here to search for a skill",
                    multiple: "",
                    filterable: "",
                    clearable: ""
                  }, {
                    arrow: _withCtx(() => [
                      _createVNode(_unref(SearchFilled))
                    ]),
                    _: 1
                  }, 8, ["value", "options"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_unref(NFormItem), {
                label: "Secondary Skills",
                path: "complementary_skills"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NSelect), {
                    value: _ctx.formData.complementary_skills,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.complementary_skills) = $event)),
                    options: _unref(skillStore).skills,
                    size: "large",
                    placeholder: "Type here to search for a skill",
                    multiple: "",
                    filterable: "",
                    clearable: ""
                  }, {
                    arrow: _withCtx(() => [
                      _createVNode(_unref(SearchFilled))
                    ]),
                    _: 1
                  }, 8, ["value", "options"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_unref(NFormItem), {
                label: "Job description",
                path: "job_description"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInput), {
                    value: _ctx.formData.job_description,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.job_description) = $event)),
                    type: "textarea",
                    autosize: { minRows: 5 },
                    size: "medium",
                    round: "",
                    placeholder: "Feel free to write or copy and paste the job description.",
                    class: "form-input"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode(_unref(NFormItem), {
                label: "Job description link",
                path: "job_description_link"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInput), {
                    value: _ctx.formData.job_description_link,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.job_description_link) = $event)),
                    type: "textarea",
                    autosize: { minRows: 2 },
                    size: "medium",
                    round: "",
                    placeholder: "You can paste the link to the job description or job posting here.",
                    class: "form-input"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_unref(NButton), {
              onClick: _withModifiers(submit, ["prevent"]),
              class: "new-project-button",
              size: "large",
              tabindex: "0"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" SAVE ")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
}
}

})